export const GETTER_LIST_HISTORY_EMPLOYEE = "GETTER_LIST_HISTORY_EMPLOYEE";
export const GETTER_LIST_HISTORY_EMPLOYEE_PAGINATION =
  "GETTER_LIST_HISTORY_EMPLOYEE_PAGINATION";

export const GETTER_LIST_HISTORY_PROFILE = "GETTER_LIST_HISTORY_PROFILE";

export const GETTER_LIST_HISTORY_PROFILE_PAGINATION =
  "GETTER_LIST_HISTORY_PROFILE_PAGINATION";

export const ACTION_GET_LIST_HISTORY_EMPLOYEE =
  "ACTION_GET_LIST_HISTORY_EMPLOYEE";
export const ACTION_LIST_HISTORY_PROFILE = "ACTION_LIST_HISTORY_PROFILE";
export const ACTION_HISTORY_REVERT_EMPLOYEE = "ACTION_HISTORY_REVERT_EMPLOYEE";
export const ACTION_HISTORY_REVERT_PROFILE = "ACTION_HISTORY_REVERT_PROFILE";

export const MUTATION_SET_LIST_HISTORY_EMPLOYEE =
  "MUTATION_SET_LIST_HISTORY_EMPLOYEE";
export const MUTATION_SET_LIST_HISTORY_PROFILE =
  "MUTATION_SET_LIST_HISTORY_PROFILE";



// WEBPACK FOOTER //
// ./src/store/modules/history/constants.js